export { default } from './ChatAdminModals';
export { default as template } from './chat-admin-modals.tpl';
